import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { ProgressAllocationPayerItem } from '../../../models/progress-allocation-payer-item';
import { ProgressAllocationService } from '../../../services/progress/progress-allocation.service';
import { SettingsService } from '../../../services/settings/settings.service';
import { Subscription } from 'rxjs';
import { RouterLink } from '@angular/router';
import { MatTooltip } from '@angular/material/tooltip';
import { MatProgressBar } from '@angular/material/progress-bar';
import { DecimalPipe, PercentPipe } from '@angular/common';

@Component({
    selector: 'app-progress-allocation-payer',
    templateUrl: './progress-allocation-payer.component.html',
    styleUrls: ['./progress-allocation-payer.component.scss'],
    imports: [RouterLink, MatTooltip, MatProgressBar, DecimalPipe, PercentPipe]
})
export class ProgressAllocationPayerComponent implements OnInit, OnDestroy {

  @Input() expanded = false;

  payerItems: ProgressAllocationPayerItem[];
  serviceYear = 0;

  closedTotal = 0;
  openTotal = 0;
  pendingTotal = 0;
  grandTotal = 0;

  subs: Subscription[] = [];

  constructor(
    private allocationService: ProgressAllocationService,
    private settingsService: SettingsService) { 
    //TODO
  }

  ngOnInit(): void {
    this.subs.push(this.settingsService.serviceYear.subscribe(result => {
      if(!result) {
        return;
      }

      this.serviceYear = result;
      this.updateData();
    }));

    this.subs.push(this.allocationService.payerAllocation.subscribe(result => {
      if(!result) {
        return;
      }

      this.payerItems = result;
      this.getTotals();
    }));
  }

  ngOnDestroy(): void {
    this.subs.forEach(s => s.unsubscribe());
  }

  updateData() {
    this.allocationService.getPayerItems(this.serviceYear);
  }

  getTotals() {
    this.closedTotal = 0;
    this.openTotal = 0;
    this.pendingTotal = 0;
    this.grandTotal = 0;
    
    this.payerItems.forEach(i => {
      this.closedTotal += i.Closed;
      this.openTotal += i.Open;
      this.pendingTotal += i.Pending;
      this.grandTotal += i.Total;
    });
  }

}
